import axios from 'axios';
import { requestExportProgress } from './exportProgress';

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/download`;

/**
 * Prepare query parameters for date range
 * @param {Object} options - Date range options
 * @returns {URLSearchParams} - URL search params object
 */
const prepareQueryParams = (options = {}) => {
  const { startDate, endDate } = options;
  
  // Build query string
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate.toISOString());
  if (endDate) params.append('endDate', endDate.toISOString());
  
  // Always use FTP
  params.append('ftp', 'true');
  
  return params;
};

/**
 * Upload Devis (quotes) as DBF files to FTP
 * @param {Object} options - Date range options
 * @returns {Promise<Object>} Result of the FTP operation
 */
export const uploadDevis = async (options = {}) => {
  const params = prepareQueryParams(options);
  const queryString = params.toString();
  const url = queryString ? `${API_URL}/devis?${queryString}` : `${API_URL}/devis`;
  
  const response = await axios.get(url);
  return response.data;
};

/**
 * Upload Devis main table only to FTP
 * @param {Object} options - Date range options
 * @returns {Promise<Object>} Result of the FTP operation
 */
export const uploadDevisMain = async (options = {}) => {
  const params = prepareQueryParams(options);
  const queryString = params.toString();
  const url = queryString ? `${API_URL}/devis-main?${queryString}` : `${API_URL}/devis-main`;
  
  const response = await axios.get(url);
  return response.data;
};

/**
 * Upload Devis detail table only to FTP
 * @param {Object} options - Date range options
 * @returns {Promise<Object>} Result of the FTP operation
 */
export const uploadDevisDetail = async (options = {}) => {
  const params = prepareQueryParams(options);
  const queryString = params.toString();
  const url = queryString ? `${API_URL}/devis-detail?${queryString}` : `${API_URL}/devis-detail`;
  
  const response = await axios.get(url);
  return response.data;
};

/**
 * Upload Bonliv (delivery notes) as DBF files to FTP
 * @param {Object} options - Date range options
 * @returns {Promise<Object>} Result of the FTP operation
 */
export const uploadBonliv = async (options = {}) => {
  const params = prepareQueryParams(options);
  const queryString = params.toString();
  const url = queryString ? `${API_URL}/bonliv?${queryString}` : `${API_URL}/bonliv`;
  
  const response = await axios.get(url);
  return response.data;
};

/**
 * Upload Bonliv main table only to FTP
 * @param {Object} options - Date range options
 * @returns {Promise<Object>} Result of the FTP operation
 */
export const uploadBonlivMain = async (options = {}) => {
  const params = prepareQueryParams(options);
  const queryString = params.toString();
  const url = queryString ? `${API_URL}/bonliv-main?${queryString}` : `${API_URL}/bonliv-main`;
  
  const response = await axios.get(url);
  return response.data;
};

/**
 * Upload Bonliv detail table only to FTP
 * @param {Object} options - Date range options
 * @returns {Promise<Object>} Result of the FTP operation
 */
export const uploadBonlivDetail = async (options = {}) => {
  const params = prepareQueryParams(options);
  const queryString = params.toString();
  const url = queryString ? `${API_URL}/bonliv-detail?${queryString}` : `${API_URL}/bonliv-detail`;
  
  const response = await axios.get(url);
  return response.data;
};

/**
 * Upload Facture (invoices) as DBF files to FTP
 * @param {Object} options - Date range options
 * @returns {Promise<Object>} Result of the FTP operation
 */
export const uploadFacture = async (options = {}) => {
  const params = prepareQueryParams(options);
  const queryString = params.toString();
  const url = queryString ? `${API_URL}/facture?${queryString}` : `${API_URL}/facture`;
  
  const response = await axios.get(url);
  return response.data;
};

/**
 * Upload Facture main table only to FTP
 * @param {Object} options - Date range options
 * @returns {Promise<Object>} Result of the FTP operation
 */
export const uploadFactureMain = async (options = {}) => {
  const params = prepareQueryParams(options);
  const queryString = params.toString();
  const url = queryString ? `${API_URL}/facture-main?${queryString}` : `${API_URL}/facture-main`;
  
  const response = await axios.get(url);
  return response.data;
};

/**
 * Upload Facture detail table only to FTP
 * @param {Object} options - Date range options
 * @returns {Promise<Object>} Result of the FTP operation
 */
export const uploadFactureDetail = async (options = {}) => {
  const params = prepareQueryParams(options);
  const queryString = params.toString();
  const url = queryString ? `${API_URL}/facture-detail?${queryString}` : `${API_URL}/facture-detail`;

  const response = await axios.get(url);
  return response.data;
};

/**
 * Upload Avoir (credit notes) as DBF files to FTP
 * @param {Object} options - Date range options
 * @returns {Promise<Object>} Result of the FTP operation
 */
export const uploadAvoir = async (options = {}) => {
  const params = prepareQueryParams(options);
  const queryString = params.toString();
  const url = queryString ? `${API_URL}/avoir?${queryString}` : `${API_URL}/avoir`;

  const response = await axios.get(url);
  return response.data;
};

/**
 * Upload Avoir main table only to FTP
 * @param {Object} options - Date range options
 * @returns {Promise<Object>} Result of the FTP operation
 */
export const uploadAvoirMain = async (options = {}) => {
  const params = prepareQueryParams(options);
  const queryString = params.toString();
  const url = queryString ? `${API_URL}/avoir-main?${queryString}` : `${API_URL}/avoir-main`;

  const response = await axios.get(url);
  return response.data;
};

/**
 * Upload Avoir detail table only to FTP
 * @param {Object} options - Date range options
 * @returns {Promise<Object>} Result of the FTP operation
 */
export const uploadAvoirDetail = async (options = {}) => {
  const params = prepareQueryParams(options);
  const queryString = params.toString();
  const url = queryString ? `${API_URL}/avoir-detail?${queryString}` : `${API_URL}/avoir-detail`;
  
  const response = await axios.get(url);
  return response.data;
};

/**
 * Upload all tables as DBF files to FTP
 * @param {Object} options - Date range options
 * @returns {Promise<Object>} Result of the FTP operation
 */
export const uploadAll = async (options = {}) => {
  const params = prepareQueryParams(options);
  const queryString = params.toString();
  const url = queryString ? `${API_URL}/all?${queryString}` : `${API_URL}/all`;
  
  const response = await axios.get(url);
  return response.data;
};

/**
 * Upload Clients as DBF file to FTP
 * @returns {Promise<Object>} Result of the FTP operation
 */
export const uploadClients = async () => {
  const response = await axios.get(`${API_URL}/clients`);
  return response.data;
};

/**
 * Upload Articles as DBF files to FTP
 * @returns {Promise<Object>} Result of the FTP operation
 */
export const uploadArticles = async () => {
  const response = await axios.get(`${API_URL}/articles`);
  return response.data;
};

/**
 * Upload all tables including reference data as DBF files to FTP
 * This exports ALL transaction tables (devis, bonliv, facture with their details)
 * AND all reference data (clients, articles) to the FTP server
 * @param {Object} options - Date range options (only applied to transaction data)
 * @returns {Promise<Object>} Result of the FTP operation
 */
export const uploadAllWithData = async (options = {}) => {
  const params = prepareQueryParams(options);
  params.append('includeAll', 'true'); // Ensure we're including all tables
  
  const queryString = params.toString();
  const url = queryString ? `${API_URL}/all-with-data?${queryString}` : `${API_URL}/all-with-data`;
  
  const response = await axios.get(url);
  return response.data;
};

/**
 * Upload files directly to FTP server
 * @param {Object} options - Options including type, date range, etc.
 * @returns {Promise<Object>} Result of the FTP upload operation
 */
export const uploadToFTP = async (options = {}) => {
  const { startDate, endDate, type = 'all' } = options;
  
  const requestData = {
    startDate: startDate ? startDate.toISOString() : null,
    endDate: endDate ? endDate.toISOString() : null,
    type
  };
  
  const response = await axios.post(`${API_URL}/ftp`, requestData);
  return response.data;
};

export const uploadAchat = async ({ type = 'all', part = 'both', startDate, endDate } = {}) => {
  const response = await axios.post(`${API_URL}/achat`, {
    type,
    part,
    startDate: startDate ? startDate.toISOString() : null,
    endDate: endDate ? endDate.toISOString() : null
  });
  return response.data;
};

export const exportWithProgress = ({ type, part = 'both', startDate, endDate, onProgress }) =>
  requestExportProgress(`${API_URL}/export-progress`, {
    type, part,
    startDate: startDate ? startDate.toISOString() : null,
    endDate: endDate ? endDate.toISOString() : null
  }, onProgress);

export const exportAchatWithProgress = ({ type = 'all', part = 'both', startDate, endDate, onProgress }) =>
  requestExportProgress(`${API_URL}/achat`, {
    type, part, progress: true,
    startDate: startDate ? startDate.toISOString() : null,
    endDate: endDate ? endDate.toISOString() : null
  }, onProgress);

export default {
  exportAchatWithProgress,
  exportWithProgress,
  uploadAchat,
  uploadDevis,
  uploadDevisMain,
  uploadDevisDetail,
  uploadBonliv,
  uploadBonlivMain,
  uploadBonlivDetail,
  uploadFacture,
  uploadFactureMain,
  uploadFactureDetail,
  uploadAvoir,
  uploadAvoirMain,
  uploadAvoirDetail,
  uploadAll,
  uploadAllWithData,
  uploadClients,
  uploadArticles,
  uploadToFTP
};
